/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 **/
import axios from "axios";
import qs from 'qs';
import router from "../router";
import store from "../store";
import { Toast } from "mint-ui";

// 提示函数
const tip = msg => {
  Toast({
    message: msg,
    duration: 2000
  });
};

// 创建axios实例
var instance = axios.create({
  baseURL: 'https://wx.xbjkyy.com/registerAdmin',
  timeout: 1000 * 12
});
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//设置axios为form-data
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data) // 转为formdata数据格式
    return config
  },
  error => Promise.error(error)
)
// 响应拦截器
// instance.interceptors.response.use(
//   // 请求成功
//   res => {
//     return Promise.resolve(res);
//   },
//   // 请求失败
//   error => {
//     const { response } = error;
//     if (response) {
//       if ((response.data.ret = 999)) {
//         tip("登录过期，请重新登录");
//         localStorage.removeItem("token");
//         store.commit("delToken");
//         setTimeout(() => {
//           toLogin();
//         }, 1000);
//       }
//       return Promise.reject(response);
//     }
//   }
// );

export default instance;
